module.exports = __webpack_public_path__ + "img/favicons/apple-touch-icon-180x180.png";


//////////////////
// WEBPACK FOOTER
// ./~/file-loader?name=[path][name].[ext]&context=./js!./js/img/favicons/apple-touch-icon-180x180.png
// module id = 1228
// module chunks = 0